import { Suspense, lazy } from 'react';
import { Navigate } from 'react-router-dom';

import SuspenseLoader from 'src/components/SuspenseLoader';

import RemotePMDLayout from 'src/layouts/RemotePMDLayout';
import pmdRoutes from 'remotePMD/pmdRoutes';

const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

const PrivacyPolicyDEVD = Loader(
  lazy(() => import('src/components/Footer/PrivacyPolicy/PrivacyPolicyDEVD.js'))
);
const PrivacyPolicyCO2 = Loader(
  lazy(() => import('src/components/Footer/PrivacyPolicy/PrivacyPolicyCO2.js'))
);

// Dashboards

const CarbonFootprint = Loader(
  lazy(() => import('src/content/dashboards/CarbonFootprint'))
);
const DEVD = Loader(lazy(() => import('src/content/dashboards/DEVD')));

const dashboardsRoutes = [
  {
    path: '',
    element: <Navigate to="policy-monitoring" replace />,
  },
  {
    path: 'policy-monitoring',
    element: <RemotePMDLayout />,
    children: pmdRoutes,
  },

  {
    path: 'dev-d/DEVD-privacy-policy', // Explicit path for Privacy Policy
    element: <PrivacyPolicyDEVD />, // Privacy policy component
  },
  {
    path: 'dev-d',
    element: <DEVD />,
  },
  {
    path: 'carbon-footprint/CO2-privacy-policy',
    element: <PrivacyPolicyCO2 />,
  },
  {
    path: 'carbon-footprint',
    element: <CarbonFootprint />,
  },
];

export default dashboardsRoutes;
